function block(item){
    const blockedItem = document.querySelector('.' + item);
    if (blockedItem) {
        blockedItem.classList.add('blocked');
    }
}

function unblock(item){
    const blockedItem = document.querySelector('.' + item);
    if (blockedItem) {
        blockedItem.classList.remove('blocked');
    }
}

function blockAll(items){
    const blockedItems = document.querySelectorAll(items);
    if (blockedItems) {
        blockedItems.forEach(blockedItem => {
            blockedItem.classList.add('blocked');
        });
    }
}

function unblockAll(items){
    const blockedItems = document.querySelectorAll(items);
    if (blockedItems) {
        blockedItems.forEach(blockedItem => {
            blockedItem.classList.remove('blocked');
        });
    }
}


export default {block, unblock, blockAll, unblockAll};


// WEBPACK FOOTER //
// ./src/scripts/block.js